<template>
    <span class="">
        <a class="customer-contact-item" href="javascript:void(0)" @click='handleCall'>
             <div class="btn-group pair_btn_new_uniq">
                <div class="d-inline clickable" data-toggle="dropdown" data-too="tooltip" data-placement="bottom"
                     aria-haspopup="true" aria-expanded="false">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.54 2C3.6 2.89 3.75 3.76 3.99 4.59L2.79 5.79C2.38 4.59 2.12 3.32 2.03 2H3.54ZM13.4 14.02C14.25 14.26 15.12 14.41 16 14.47V15.96C14.68 15.87 13.41 15.61 12.2 15.21L13.4 14.02ZM4.5 0H1C0.45 0 0 0.45 0 1C0 10.39 7.61 18 17 18C17.55 18 18 17.55 18 17V13.51C18 12.96 17.55 12.51 17 12.51C15.76 12.51 14.55 12.31 13.43 11.94C13.33 11.9 13.22 11.89 13.12 11.89C12.86 11.89 12.61 11.99 12.41 12.18L10.21 14.38C7.38 12.93 5.06 10.62 3.62 7.79L5.82 5.59C6.1 5.31 6.18 4.92 6.07 4.57C5.7 3.45 5.5 2.25 5.5 1C5.5 0.45 5.05 0 4.5 0Z" fill="#2E4051"/>
                    </svg>

                </div>
             </div>
        </a>
    </span>
</template>
<script>
export default {
    name: "CustomerCallBtn",
    props: ['theme','call_target','mobile_link','call_web_link','customer_name_without_quote','customer_numbers','hasViewCredential'],
    methods: {
        handleCall(){
            this.hidePopover();
            regularCallPopup(this.call_target,this.mobile_link,this.call_web_link,this.customer_name_without_quote,this.customer_numbers,this.hasViewCredential)
        },
        hidePopover() {
            // $('.customerPopoverBtn').popover('hide');
            $(".customerPopoverBtn").each(function () {
                var $this = $(this);
                $this.popover('hide');
            });
        }
    }

}
</script>